module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sideways-page-one"
  }, [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "show-modal",
    staticStyle: {
      "z-index": "9999",
      "position": "fixed",
      "top": "0",
      "left": "0",
      "height": "100vh",
      "width": "100vw",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "background-color": "rgba(0,0,0,0.5)"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "white",
      "border-radius": "4px",
      "width": "700px",
      "height": "500px",
      "padding": "20px",
      "align-items": "center",
      "display": "flex",
      "flex-direction": "column"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h2', [_vm._v(" Select Day, Start time and Date range")]), _vm._v(" "), _c('div', [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.multipleDays),
      callback: function($$v) {
        _vm.multipleDays = $$v
      },
      expression: "multipleDays"
    }
  }, _vm._l((_vm.days), function(item, i) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": i
      }
    })
  }))], 1), _vm._v(" "), _c('div', [_c('el-time-picker', {
    attrs: {
      "placeholder": "Select Start Time"
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": " - ",
      "placeholder": "Select range",
      "start-placeholder": "Start date",
      "end-placeholder": "End date"
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    class: {
      'clickable-blue': _vm.multipleDays !== null && _vm.startTime !== null && _vm.dateRange !== null
    },
    staticStyle: {
      "background-color": "grey",
      "pointer-events": "none"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addLimitedTimePlaylist({
          start_time: _vm.timeFormat(_vm.startTime),
          presentation_id: _vm.selectedPresentation.presentation_id,
          day_of_week: _vm.multipleDays,
          playlist_type: 'one-time',
          start_datetime_range: _vm.dateFormat(_vm.dateRange[0]),
          end_datetime_range: _vm.dateFormat(_vm.dateRange[1])
        })
      }
    }
  }, [_vm._v(" Add ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.step === 0) ? _c('div', {
    staticClass: "flex-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.createPres(), _vm.getLayouts()
      }
    }
  }, [_vm._v(" Create a new Presentation")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setStep(3), _vm.getPresentations()
      }
    }
  }, [_vm._v(" Open existing Presentation")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('div', {
    staticClass: "flex-center"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_vm._l((_vm.layoutList), function(layout, index) {
    return [_c('el-button', {
      staticStyle: {
        "width": "25%"
      },
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.setActiveLayout(index)
        }
      }
    }, [_vm._v(" " + _vm._s(layout.name) + " w: " + _vm._s(layout.width) + " h: " + _vm._s(layout.height) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', {
    staticClass: "flex-center"
  }, [_vm._m(2), _vm._v(" "), _c('div', [_vm._l((_vm.presentationList), function(pres, index) {
    return [_c('el-button', {
      staticStyle: {
        "width": "25%"
      },
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.selectPres(index)
        }
      }
    }, [_vm._v(" " + _vm._s(pres.name) + " ")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          _vm.deletePres(pres.presentation_id, index)
        }
      }
    }, [_vm._v(" Delete ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', {
    staticClass: "flex-center"
  }, [_c('div', [_c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.showAll()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\tShow all Displays\n\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.showOne()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-stop fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\tShow One Display\n\t\t")]), _vm._v(" "), _c('div', [_c('h1', [_vm._v(" Presentation: " + _vm._s(_vm.selectedPresentation.name) + " ")])])]), _vm._v(" "), (_vm.displayNumber !== false) ? [_c('div', [_c('div', [_c('h1', [_vm._v(" Layout: " + _vm._s(_vm.name) + " (Display " + _vm._s(_vm.displayNumber + 1) + "/" + _vm._s(_vm.displayCount) + ")")])]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    attrs: {
      "disabled": !_vm.displayNumber > 0
    },
    on: {
      "click": function($event) {
        _vm.prevDisplay()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tPrevious Display\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tFullscreen\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    attrs: {
      "disabled": !(this.displayNumber < this.displayCount - 1)
    },
    on: {
      "click": function($event) {
        _vm.nextDisplay()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tNext Display\n\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "auto!important",
      "padding": "5px"
    },
    style: ({
      'margin-bottom': _vm.padding + 'px'
    })
  }, [_c('fs', {
    ref: "fs",
    attrs: {
      "fullscreen": _vm.fullscreen
    },
    on: {
      "update:fullscreen": function($event) {
        _vm.fullscreen = $event
      }
    }
  }, [_c('div', {
    staticClass: "layout-editor",
    staticStyle: {
      "position": "relative",
      "transform-origin": "top",
      "outline": "5px solid black"
    },
    style: ({
      width: _vm.layoutWidth + 'px',
      height: _vm.layoutHeight + 'px',
      transform: 'scale(' + _vm.demoScale + ',' + _vm.demoScale + ')',
      'background-size': _vm.grid + 'px ' + _vm.grid + 'px'
    })
  }, [_vm._l((_vm.zones), function(region, i) {
    return (region.background !== 'transparent' && region.screen === _vm.displayNumber && !region.limited) ? [_c('vue-draggable-resizable', {
      staticClass: "demo-region",
      class: {
        'selected-playlist-text': _vm.selectedPlaylist === i, 'seethru': _vm.selectedPlaylist !== null && _vm.fullscreen === false
      },
      style: ({
        'background-color': region.background
      }),
      attrs: {
        "draggable": false,
        "resizable": false,
        "grid": [_vm.grid, _vm.grid],
        "id": ("region-" + i),
        "index": i,
        "x": region.x,
        "y": region.y,
        "w": region.width,
        "h": region.height,
        "z": region.z,
        "parent": true
      },
      on: {
        "activated": function($event) {
          _vm.selectPlaylist(i)
        }
      }
    }, [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])]) ? [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource) ? [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'mp4') ? _c('video', {
      key: ("video-" + (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url)),
      staticClass: "autoPlayMe",
      attrs: {
        "width": region.width,
        "height": region.height,
        "loop": "",
        "autoplay": ""
      }
    }, [_c('source', {
      attrs: {
        "src": _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url,
        "type": "video/mp4"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\tYour browser does not support HTML5 video.\n\t\t\t\t\t\t\t\t")]) : (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'png' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'jpg' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'jpeg' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'gif') ? _c('div', {
      staticClass: "imageContainer",
      style: ({
        width: region.width + 'px',
        height: region.height + 'px',
        'background': 'url(' + _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url + ')'
      })
    }) : (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'html') ? _c('div', {
      staticStyle: {
        "background-color": "white!important"
      },
      style: ({
        width: region.width + 'px',
        height: region.height + 'px',
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url)
      }
    }) : _vm._e()] : _c('span', {
      staticStyle: {
        "flex-align": "center",
        "align-items": "center",
        "display": "flex",
        "flex-direction": "column",
        "background-color": "rgba(0,0,0,0.5)",
        "color": "white",
        "border-radius": "4px",
        "padding": "1%",
        "font-size": "25px"
      }
    }, [_c('h1', {
      staticStyle: {
        "margin-top": "5%"
      }
    }, [_vm._v(" " + _vm._s(region.name) + " ")]), _vm._v("\n\t\t\t\t\t\t\t\tGroup: " + _vm._s(region.group) + "\n\t\t\t\t\t\t\t")])] : _c('span', {
      staticStyle: {
        "flex-align": "center",
        "align-items": "center",
        "display": "flex",
        "flex-direction": "column",
        "background-color": "rgba(0,0,0,0.5)",
        "color": "white",
        "border-radius": "4px",
        "padding": "1%",
        "font-size": "25px"
      }
    }, [_c('h1', {
      staticStyle: {
        "margin-top": "5%"
      }
    }, [_vm._v(" " + _vm._s(region.name) + " ")]), _vm._v("\n\t\t\t\t\t\t\tGroup: " + _vm._s(region.group) + "\n\t\t\t\t\t\t")])], 2)] : _vm._e()
  })], 2)])], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button btn",
    class: {
      'clickable-white': !_vm.play
    },
    staticStyle: {
      "background-color": "grey",
      "pointer-events": "none"
    },
    on: {
      "click": function($event) {
        _vm.addNewRegion()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tAdd\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    class: {
      'clickable-white': !_vm.play
    },
    staticStyle: {
      "background-color": "grey",
      "pointer-events": "none"
    },
    on: {
      "click": function($event) {
        _vm.deleteRegion()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tDelete\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.save(_vm.selectedPresentation.presentation_id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tSave\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.setStep(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tCancel\n\t\t\t")]), _vm._v(" "), _c('resource-modal', {
    staticStyle: {
      "position": "absolute",
      "bottom": "-10vh"
    },
    attrs: {
      "id": "invisible-button",
      "buttonText": 'Select content'
    },
    on: {
      "selected": _vm.selectedResource
    }
  })], 1), _vm._v(" "), _c('div', [(!_vm.play) ? _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play fa-2x"
  })]) : _vm._e(), _vm._v(" "), (_vm.play) ? _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.stop()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-stop fa-2x"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n\t\t\tMax Time (s) of playlist\n\t\t\t"), _c('el-slider', {
    attrs: {
      "step": 5,
      "show-input": "",
      "min": 10,
      "max": 10000
    },
    model: {
      value: (_vm.maxTime),
      callback: function($$v) {
        _vm.maxTime = $$v
      },
      expression: "maxTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "region-block",
    staticStyle: {
      "margin": "0 !important",
      "display": "inline-block",
      "float": "left",
      "width": "100px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "50px",
      "width": "100px"
    }
  }, [(_vm.groupModeOn) ? _c('button', {
    style: ({
      'background-color': _vm.colorHash('', _vm.selectedGroup)
    }),
    on: {
      "click": function($event) {
        _vm.groupMode()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-object-group"
  })]) : _c('button', {
    on: {
      "click": function($event) {
        _vm.groupMode()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-object-group"
  })])]), _vm._v(" "), _vm._l((_vm.zones), function(region, j) {
    return (_vm.zones[j].screen === _vm.displayNumber) ? _c('div', {
      class: {
        'groupHover': _vm.groupModeOn
      },
      staticStyle: {
        "width": "100%",
        "display": "inline-block",
        "margin": "0",
        "padding": "0"
      },
      on: {
        "click": function($event) {
          _vm.selectPlaylist(j), _vm.groupToggle(j)
        }
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "display": "flex",
        "justify-content": "center",
        "align-items": "center",
        "flex-direction": "row"
      }
    }, [(region.group !== false) ? _c('span', {
      staticStyle: {
        "width": "10%",
        "top": "0",
        "left": "0",
        "height": "50px",
        "border": "1px solid black"
      },
      style: ({
        'background-color': _vm.colorHash('', region.group)
      })
    }) : _c('span', {
      staticStyle: {
        "width": "10%",
        "top": "0",
        "left": "0",
        "height": "50px",
        "background-color": "transparent"
      }
    }), _vm._v(" "), _c('p', {
      class: {
        'selected-playlist-text': _vm.selectedPlaylist === j
      },
      staticStyle: {
        "margin-left": "0",
        "margin-top": "0",
        "margin-bottom": "0",
        "margin-right": "15px",
        "width": "90%",
        "flex-direction": "column",
        "display": "flex",
        "justify-content": "center",
        "align-items": "center",
        "background-color": "white",
        "padding": "0",
        "line-height": "20px",
        "height": "50px",
        "opacity": "0.5"
      },
      style: ({
        'background-color': _vm.zones[j].background
      })
    }, [(!region.limited) ? _c('span', {
      staticStyle: {
        "flex-align": "center",
        "align-items": "center",
        "display": "flex",
        "flex-direction": "column",
        "background-color": "rgba(0,0,0,0.5)",
        "color": "white",
        "border-radius": "2px",
        "padding": "2px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(region.name) + " \n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (region.limited) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.days[region.limited.day_of_week] + ' one time at ' + region.limited.start_time + ' ' + region.limited.start_datetime_range + ' to ' + region.limited.end_datetime_range,
        "placement": "top-start"
      }
    }, [_c('span', {
      staticStyle: {
        "flex-align": "center",
        "align-items": "center",
        "display": "flex",
        "flex-direction": "column",
        "background-color": "rgba(0,0,0,0.5)",
        "color": "white",
        "border-radius": "2px",
        "padding": "2px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(region.name) + ": " + _vm._s(_vm.daysShort[region.limited.day_of_week]) + " \n\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (region.limited) ? _c('button', {
      staticStyle: {
        "color": "black"
      },
      on: {
        "click": function($event) {
          _vm.removePlaylist(j)
        }
      }
    }, [_vm._v(" - ")]) : _vm._e()], 1)])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "playlist-block",
    staticStyle: {
      "white-space": "nowrap",
      "overflow-x": "auto",
      "overflow-y": "hidden"
    }
  }, [_c('div', {
    staticClass: "playlist",
    staticStyle: {
      "height": "50px",
      "background-image": "linear-gradient(to right, lightgrey 1px, transparent 1px),linear-gradient(to bottom, transparent 1px, transparent 1px)",
      "position": "relative",
      "transform-origin": "top",
      "outline": "1px solid transparent"
    },
    style: ({
      width: _vm.maxTime * _vm.scale + 'px',
      'background-size': _vm.scale + 'px ' + _vm.height + 'px'
    })
  }, _vm._l((_vm.maxTime + 1), function(n, i) {
    return ((n - 1) % 10 === 0 || (n - 1) % 5 === 0) ? _c('span', {
      class: {
        'floatLeft': i !== _vm.maxTime
      },
      staticStyle: {
        "text-align": "left",
        "z-index": "9",
        "left": "0",
        "position": "relative"
      },
      style: ({
        width: _vm.scale * 5 + 'px'
      })
    }, [_c('span', {
      staticStyle: {
        "margin-left": "2px"
      }
    }, [_vm._v(" " + _vm._s(n - 1) + "s ")]), _vm._v(" "), ((n - 1) % 10 === 0) ? _c('span', {
      staticStyle: {
        "position": "absolute",
        "left": "0",
        "height": "30px",
        "border-left": "1px solid black"
      }
    }) : ((n - 1) % 5 === 0) ? _c('span', {
      staticStyle: {
        "position": "absolute",
        "left": "0",
        "height": "20px",
        "border-left": "1px solid black"
      }
    }) : _vm._e()]) : _vm._e()
  })), _vm._v(" "), _vm._l((_vm.regionList), function(regions, j) {
    return (_vm.zones[j].screen === _vm.displayNumber) ? _c('div', {
      staticClass: "playlist",
      staticStyle: {
        "height": "50px",
        "background-image": "linear-gradient(to right, lightgrey 1px, transparent 1px), linear-gradient(to bottom, transparent 1px, transparent 1px)",
        "position": "relative",
        "transform-origin": "top",
        "outline": "1px solid transparent"
      },
      style: ({
        width: _vm.maxTime * _vm.scale + 'px',
        'background-size': _vm.scale + 'px ' + _vm.height + 'px'
      })
    }, [(_vm.zones[j].group === false) ? _c('el-slider', {
      attrs: {
        "min": 0,
        "max": _vm.maxTime,
        "show-tooltip": false
      },
      model: {
        value: (_vm.players[j]),
        callback: function($$v) {
          _vm.$set(_vm.players, j, $$v)
        },
        expression: "players[j]"
      }
    }) : _c('el-slider', {
      attrs: {
        "min": 0,
        "max": _vm.maxTime,
        "show-tooltip": false
      },
      model: {
        value: (_vm.players[_vm.getIndexOfStartGroup(_vm.zones[j].group)]),
        callback: function($$v) {
          _vm.$set(_vm.players, _vm.getIndexOfStartGroup(_vm.zones[j].group), $$v)
        },
        expression: "players[getIndexOfStartGroup(zones[j].group)]"
      }
    }), _vm._v(" "), _vm._l((regions), function(region, i) {
      return [(region.del !== true) ? _c('vue-draggable-resizable', {
        staticClass: "region",
        class: {
          'selected-playlist': _vm.selectedPlaylist === j,
            'selected-region': _vm.selectedRegion === i && _vm.selectedPlaylist === j
        },
        staticStyle: {
          "border": "1px solid grey",
          "display": "flex",
          "justify-content": "center",
          "align-items": "center",
          "height": "50px",
          "background-color": "white"
        },
        attrs: {
          "draggable": false,
          "grid": [_vm.scale, _vm.height],
          "minw": _vm.scale,
          "id": ("region-" + j + "-" + i),
          "playlist": j,
          "index": i,
          "z": region.z,
          "x": region.x,
          "y": region.y,
          "w": region.width,
          "parent": true
        },
        on: {
          "mouseOver": _vm.hoverButton,
          "mouseLeave": _vm.leaveButton,
          "resizing": _vm.onResize,
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
          },
          "update:z": function($event) {
            _vm.$set(region, "z", $event)
          },
          "update:x": function($event) {
            _vm.$set(region, "x", $event)
          },
          "update:w": function($event) {
            _vm.$set(region, "width", $event)
          }
        }
      }, [(region.resource) ? [(region.resource.extension === 'mp4') ? _c('video', {
        key: ("thumb-" + (region.resource.url)),
        attrs: {
          "width": region.width,
          "height": 50,
          "loop": ""
        }
      }, [_c('source', {
        attrs: {
          "src": region.resource.url,
          "type": "video/mp4"
        }
      }), _vm._v("\n\t\t\t\t\t\t\t\t\tYour browser does not support HTML5 video.\n\t\t\t\t\t\t\t\t")]) : (region.resource.extension === 'png' || region.resource.extension === 'jpg' || region.resource.extension === 'jpeg' || region.resource.extension === 'gif') ? _c('div', {
        staticClass: "imageContainer",
        style: ({
          width: region.width + 'px',
          height: 50 + 'px',
          'background': 'url(' + region.resource.url + ')'
        })
      }) : (region.resource.extension === 'html') ? _c('div', {
        staticStyle: {
          "background-color": "white!important"
        },
        style: ({
          width: region.width + 'px',
          height: region.height + 'px',
        }),
        domProps: {
          "innerHTML": _vm._s(region.resource.url)
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showButtons[0] === i && _vm.showButtons[1] === j),
          expression: "showButtons[0] === i && showButtons[1] === j"
        }],
        staticStyle: {
          "border-radius": "2px",
          "padding": "2px",
          "position": "absolute",
          "bottom": "25px",
          "color": "white",
          "background-color": "rgba(0, 0, 0, 0.5)"
        }
      }, [_vm._v("  " + _vm._s(parseInt(region.x / _vm.scale)) + "-" + _vm._s(parseInt((region.x / _vm.scale) + (region.width / _vm.scale))) + " ")]), _vm._v(" "), _c('button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showButtons[0] === i && _vm.showButtons[1] === j),
          expression: "showButtons[0] === i && showButtons[1] === j"
        }],
        staticClass: "btn button",
        staticStyle: {
          "position": "absolute",
          "bottom": "0",
          "width": "30px",
          "font-size": "10px",
          "padding": "0",
          "height": "25px"
        },
        on: {
          "click": function($event) {
            _vm.clickInvisibleButton(j, i)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-2x fa-upload",
        staticStyle: {
          "color": "black"
        }
      })])] : (region.width > 30) ? _c('div', {
        staticStyle: {
          "display": "flex",
          "flex-direction": "column"
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t  " + _vm._s(parseInt(region.x / _vm.scale)) + "-" + _vm._s(parseInt((region.x / _vm.scale) + (region.width / _vm.scale))) + "\n\t\t\t\t\t\t\t\t"), _c('button', {
        staticClass: "btn button",
        staticStyle: {
          "width": "30px",
          "font-size": "10px",
          "padding": "0",
          "height": "25px"
        },
        on: {
          "click": function($event) {
            _vm.clickInvisibleButton(j, i)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-2x fa-upload",
        staticStyle: {
          "color": "black"
        }
      })])]) : _vm._e()], 2) : _vm._e()]
    })], 2) : _vm._e()
  })], 2)])] : [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "flex-direction": "column"
    }
  }, [_c('div', [_c('h1', [_vm._v(" Layout: " + _vm._s(_vm.name) + " " + _vm._s(_vm.actualWidth) + " x " + _vm._s(_vm.layoutHeight))])]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrows-alt fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tFullscreen\n\t\t\t")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "auto!important",
      "padding": "5px"
    },
    style: ({
      'margin-bottom': _vm.padding + 'px'
    })
  }, [_c('fs', {
    ref: "fs",
    attrs: {
      "fullscreen": _vm.fullscreen
    },
    on: {
      "update:fullscreen": function($event) {
        _vm.fullscreen = $event
      }
    }
  }, [_c('div', {
    staticClass: "layout-editor",
    staticStyle: {
      "position": "relative",
      "transform-origin": "top",
      "outline": "5px solid black"
    },
    style: ({
      width: _vm.actualWidth + 'px',
      height: _vm.layoutHeight + 'px',
      transform: 'scale(' + _vm.demoScale + ',' + _vm.demoScale + ')',
      'background-size': _vm.grid + 'px ' + _vm.grid + 'px'
    })
  }, [_vm._l((_vm.zones), function(region, i) {
    return (region.background !== 'transparent' && !region.limited) ? [_c('vue-draggable-resizable', {
      staticClass: "demo-region",
      class: {
        'selected-playlist-text': _vm.selectedPlaylist === i, 'seethru': _vm.selectedPlaylist !== null && _vm.fullscreen === false
      },
      style: ({
        'background-color': region.background
      }),
      attrs: {
        "draggable": false,
        "resizable": false,
        "grid": [_vm.grid, _vm.grid],
        "id": ("region-" + i),
        "index": i,
        "x": region.actual_x,
        "y": region.y,
        "w": region.width,
        "h": region.height,
        "z": region.z,
        "parent": true
      },
      on: {
        "activated": function($event) {
          _vm.selectPlaylist(i)
        },
        "mouseOver": _vm.hoverButton
      }
    }, [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])]) ? [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource) ? [(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'mp4') ? _c('video', {
      key: ("video-" + (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url)),
      staticClass: "autoPlayMe",
      attrs: {
        "width": region.width,
        "height": region.height,
        "loop": "",
        "autoplay": ""
      }
    }, [_c('source', {
      attrs: {
        "src": _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url,
        "type": "video/mp4"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\tYour browser does not support HTML5 video.\n\t\t\t\t\t\t\t\t")]) : (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'png' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'jpg' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'jpeg' || _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'gif') ? _c('div', {
      staticClass: "imageContainer",
      style: ({
        width: region.width + 'px',
        height: region.height + 'px',
        'background': 'url(' + _vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url + ')'
      })
    }) : (_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.extension === 'html') ? _c('div', {
      staticStyle: {
        "background-color": "white!important"
      },
      style: ({
        width: region.width + 'px',
        height: region.height + 'px',
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.regionList[i][_vm.regionFromTime(i, _vm.players[i])].resource.url)
      }
    }) : _vm._e()] : _c('span', {
      staticStyle: {
        "flex-align": "center",
        "align-items": "center",
        "display": "flex",
        "flex-direction": "column",
        "background-color": "rgba(0,0,0,0.5)",
        "color": "white",
        "border-radius": "4px",
        "padding": "1%",
        "font-size": "25px"
      }
    }, [_c('h1', {
      staticStyle: {
        "margin-top": "5%"
      }
    }, [_vm._v(" " + _vm._s(region.name) + " ")]), _vm._v("\n\t\t\t\t\t\t\t\tGroup: " + _vm._s(region.group) + "\n\t\t\t\t\t\t\t")])] : _c('span', {
      staticStyle: {
        "flex-align": "center",
        "align-items": "center",
        "display": "flex",
        "flex-direction": "column",
        "background-color": "rgba(0,0,0,0.5)",
        "color": "white",
        "border-radius": "4px",
        "padding": "1%",
        "font-size": "25px"
      }
    }, [_c('h1', {
      staticStyle: {
        "margin-top": "5%"
      }
    }, [_vm._v(" " + _vm._s(region.name) + " ")]), _vm._v("\n\t\t\t\t\t\t\tGroup: " + _vm._s(region.group) + "\n\t\t\t\t\t\t")])], 2)] : _vm._e()
  })], 2)])], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button btn",
    class: {
      'clickable-white': !_vm.play
    },
    staticStyle: {
      "background-color": "grey",
      "pointer-events": "none"
    },
    on: {
      "click": function($event) {
        _vm.addNewRegion()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tAdd\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    class: {
      'clickable-white': !_vm.play
    },
    staticStyle: {
      "background-color": "grey",
      "pointer-events": "none"
    },
    on: {
      "click": function($event) {
        _vm.deleteRegion()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tDelete\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.save(_vm.selectedPresentation.presentation_id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tSave\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.setStep(0)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-2x"
  }), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\tCancel\n\t\t\t")]), _vm._v(" "), _c('resource-modal', {
    staticStyle: {
      "position": "absolute",
      "bottom": "-10vh"
    },
    attrs: {
      "id": "invisible-button",
      "buttonText": 'Select content'
    },
    on: {
      "selected": _vm.selectedResource
    }
  })], 1), _vm._v(" "), _c('div', [(!_vm.play) ? _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-play fa-2x"
  })]) : _vm._e(), _vm._v(" "), (_vm.play) ? _c('button', {
    staticClass: "button btn",
    on: {
      "click": function($event) {
        _vm.stop()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-stop fa-2x"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n\t\t\tMax Time (s) of playlist\n\t\t\t"), _c('el-slider', {
    attrs: {
      "step": 5,
      "show-input": "",
      "min": 10,
      "max": 10000
    },
    model: {
      value: (_vm.maxTime),
      callback: function($$v) {
        _vm.maxTime = $$v
      },
      expression: "maxTime"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "region-block",
    staticStyle: {
      "margin": "0 !important",
      "display": "inline-block",
      "float": "left",
      "width": "100px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "50px",
      "width": "100px"
    }
  }, [(_vm.groupModeOn) ? _c('button', {
    style: ({
      'background-color': _vm.colorHash('', _vm.selectedGroup)
    }),
    on: {
      "click": function($event) {
        _vm.groupMode()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-object-group"
  })]) : _c('button', {
    on: {
      "click": function($event) {
        _vm.groupMode()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-object-group"
  })])]), _vm._v(" "), _vm._l((_vm.zones), function(region, j) {
    return _c('div', {
      class: {
        'groupHover': _vm.groupModeOn
      },
      staticStyle: {
        "width": "100%",
        "display": "inline-block",
        "margin": "0",
        "padding": "0"
      },
      on: {
        "click": function($event) {
          _vm.selectPlaylist(j), _vm.groupToggle(j)
        }
      }
    }, [_c('div', {
      staticClass: "row",
      staticStyle: {
        "display": "flex",
        "justify-content": "center",
        "align-items": "center",
        "flex-direction": "row"
      }
    }, [(region.group !== false) ? _c('span', {
      staticStyle: {
        "width": "10%",
        "top": "0",
        "left": "0",
        "height": "50px",
        "border": "1px solid black"
      },
      style: ({
        'background-color': _vm.colorHash('', region.group)
      })
    }) : _c('span', {
      staticStyle: {
        "width": "10%",
        "top": "0",
        "left": "0",
        "height": "50px",
        "background-color": "transparent"
      }
    }), _vm._v(" "), _c('p', {
      class: {
        'selected-playlist-text': _vm.selectedPlaylist === j
      },
      staticStyle: {
        "margin-left": "0",
        "margin-top": "0",
        "margin-bottom": "0",
        "margin-right": "15px",
        "width": "90%",
        "flex-direction": "column",
        "display": "flex",
        "justify-content": "center",
        "align-items": "center",
        "background-color": "white",
        "padding": "0",
        "line-height": "20px",
        "height": "50px",
        "opacity": "0.5"
      },
      style: ({
        'background-color': _vm.zones[j].background
      })
    }, [(!region.limited) ? _c('span', {
      staticStyle: {
        "flex-align": "center",
        "align-items": "center",
        "display": "flex",
        "flex-direction": "column",
        "background-color": "rgba(0,0,0,0.5)",
        "color": "white",
        "border-radius": "2px",
        "padding": "2px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(region.name) + " \n\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (region.limited) ? _c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": _vm.days[region.limited.day_of_week] + ' one time at ' + region.limited.start_time + ' ' + region.limited.start_datetime_range + ' to ' + region.limited.end_datetime_range,
        "placement": "top-start"
      }
    }, [_c('span', {
      staticStyle: {
        "flex-align": "center",
        "align-items": "center",
        "display": "flex",
        "flex-direction": "column",
        "background-color": "rgba(0,0,0,0.5)",
        "color": "white",
        "border-radius": "2px",
        "padding": "2px"
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(region.name) + ": " + _vm._s(_vm.daysShort[region.limited.day_of_week]) + " \n\t\t\t\t\t\t\t\t")])]) : _vm._e(), _vm._v(" "), (region.limited) ? _c('button', {
      staticStyle: {
        "color": "black"
      },
      on: {
        "click": function($event) {
          _vm.removePlaylist(j)
        }
      }
    }, [_vm._v(" - ")]) : _vm._e()], 1)])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "playlist-block",
    staticStyle: {
      "white-space": "nowrap",
      "overflow-x": "auto",
      "overflow-y": "hidden"
    }
  }, [_c('div', {
    staticClass: "playlist",
    staticStyle: {
      "height": "50px",
      "background-image": "linear-gradient(to right, lightgrey 1px, transparent 1px),linear-gradient(to bottom, transparent 1px, transparent 1px)",
      "position": "relative",
      "transform-origin": "top",
      "outline": "1px solid transparent"
    },
    style: ({
      width: _vm.maxTime * _vm.scale + 'px',
      'background-size': _vm.scale + 'px ' + _vm.height + 'px'
    })
  }, _vm._l((_vm.maxTime + 1), function(n, i) {
    return ((n - 1) % 10 === 0 || (n - 1) % 5 === 0) ? _c('span', {
      class: {
        'floatLeft': i !== _vm.maxTime
      },
      staticStyle: {
        "text-align": "left",
        "z-index": "9",
        "left": "0",
        "position": "relative"
      },
      style: ({
        width: _vm.scale * 5 + 'px'
      })
    }, [_c('span', {
      staticStyle: {
        "margin-left": "2px"
      }
    }, [_vm._v(" " + _vm._s(n - 1) + "s ")]), _vm._v(" "), ((n - 1) % 10 === 0) ? _c('span', {
      staticStyle: {
        "position": "absolute",
        "left": "0",
        "height": "30px",
        "border-left": "1px solid black"
      }
    }) : ((n - 1) % 5 === 0) ? _c('span', {
      staticStyle: {
        "position": "absolute",
        "left": "0",
        "height": "20px",
        "border-left": "1px solid black"
      }
    }) : _vm._e()]) : _vm._e()
  })), _vm._v(" "), _vm._l((_vm.regionList), function(regions, j) {
    return _c('div', {
      staticClass: "playlist",
      staticStyle: {
        "height": "50px",
        "background-image": "linear-gradient(to right, lightgrey 1px, transparent 1px), linear-gradient(to bottom, transparent 1px, transparent 1px)",
        "position": "relative",
        "transform-origin": "top",
        "outline": "1px solid transparent"
      },
      style: ({
        width: _vm.maxTime * _vm.scale + 'px',
        'background-size': _vm.scale + 'px ' + _vm.height + 'px'
      })
    }, [(_vm.zones[j].group === false) ? _c('el-slider', {
      attrs: {
        "min": 0,
        "max": _vm.maxTime,
        "show-tooltip": false
      },
      model: {
        value: (_vm.players[j]),
        callback: function($$v) {
          _vm.$set(_vm.players, j, $$v)
        },
        expression: "players[j]"
      }
    }) : _c('el-slider', {
      attrs: {
        "min": 0,
        "max": _vm.maxTime,
        "show-tooltip": false
      },
      model: {
        value: (_vm.players[_vm.getIndexOfStartGroup(_vm.zones[j].group)]),
        callback: function($$v) {
          _vm.$set(_vm.players, _vm.getIndexOfStartGroup(_vm.zones[j].group), $$v)
        },
        expression: "players[getIndexOfStartGroup(zones[j].group)]"
      }
    }), _vm._v(" "), _vm._l((regions), function(region, i) {
      return [(region.del !== true) ? _c('vue-draggable-resizable', {
        staticClass: "region",
        class: {
          'selected-playlist': _vm.selectedPlaylist === j,
            'selected-region': _vm.selectedRegion === i && _vm.selectedPlaylist === j
        },
        staticStyle: {
          "border": "1px solid grey",
          "display": "flex",
          "justify-content": "center",
          "align-items": "center",
          "height": "50px",
          "background-color": "white"
        },
        attrs: {
          "draggable": false,
          "grid": [_vm.scale, _vm.height],
          "minw": _vm.scale,
          "id": ("region-" + j + "-" + i),
          "playlist": j,
          "index": i,
          "z": region.z,
          "x": region.x,
          "y": region.y,
          "w": region.width,
          "parent": true
        },
        on: {
          "mouseOver": _vm.hoverButton,
          "mouseLeave": _vm.leaveButton,
          "resizing": _vm.onResize,
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
          },
          "update:z": function($event) {
            _vm.$set(region, "z", $event)
          },
          "update:x": function($event) {
            _vm.$set(region, "x", $event)
          },
          "update:w": function($event) {
            _vm.$set(region, "width", $event)
          }
        }
      }, [(region.resource) ? [(region.resource.extension === 'mp4') ? _c('video', {
        key: ("thumb-" + (region.resource.url)),
        attrs: {
          "width": region.width,
          "height": 50,
          "loop": ""
        }
      }, [_c('source', {
        attrs: {
          "src": region.resource.url,
          "type": "video/mp4"
        }
      }), _vm._v("\n\t\t\t\t\t\t\t\t\tYour browser does not support HTML5 video.\n\t\t\t\t\t\t\t\t")]) : (region.resource.extension === 'png' || region.resource.extension === 'jpg' || region.resource.extension === 'jpeg' || region.resource.extension === 'gif') ? _c('div', {
        staticClass: "imageContainer",
        style: ({
          width: region.width + 'px',
          height: 50 + 'px',
          'background': 'url(' + region.resource.url + ')'
        })
      }) : (region.resource.extension === 'html') ? _c('div', {
        staticStyle: {
          "background-color": "white!important"
        },
        style: ({
          width: region.width + 'px',
          height: region.height + 'px',
        }),
        domProps: {
          "innerHTML": _vm._s(region.resource.url)
        }
      }) : _vm._e(), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showButtons[0] === i && _vm.showButtons[1] === j),
          expression: "showButtons[0] === i && showButtons[1] === j"
        }],
        staticStyle: {
          "border-radius": "2px",
          "padding": "2px",
          "position": "absolute",
          "bottom": "25px",
          "color": "white",
          "background-color": "rgba(0, 0, 0, 0.5)"
        }
      }, [_vm._v("  " + _vm._s(parseInt(region.x / _vm.scale)) + "-" + _vm._s(parseInt((region.x / _vm.scale) + (region.width / _vm.scale))) + " ")]), _vm._v(" "), _c('button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.showButtons[0] === i && _vm.showButtons[1] === j),
          expression: "showButtons[0] === i && showButtons[1] === j"
        }],
        staticClass: "btn button",
        staticStyle: {
          "position": "absolute",
          "bottom": "0",
          "width": "30px",
          "font-size": "10px",
          "padding": "0",
          "height": "25px"
        },
        on: {
          "click": function($event) {
            _vm.clickInvisibleButton(j, i)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-2x fa-upload",
        staticStyle: {
          "color": "black"
        }
      })])] : (region.width > 30) ? _c('div', {
        staticStyle: {
          "display": "flex",
          "flex-direction": "column"
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t  " + _vm._s(parseInt(region.x / _vm.scale)) + "-" + _vm._s(parseInt((region.x / _vm.scale) + (region.width / _vm.scale))) + "\n\t\t\t\t\t\t\t\t"), _c('button', {
        staticClass: "btn button",
        staticStyle: {
          "width": "30px",
          "font-size": "10px",
          "padding": "0",
          "height": "25px"
        },
        on: {
          "click": function($event) {
            _vm.clickInvisibleButton(j, i)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-2x fa-upload",
        staticStyle: {
          "color": "black"
        }
      })])]) : _vm._e()], 2) : _vm._e()]
    })], 2)
  })], 2)])]], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(" Presentation Editor ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(" Select a layout ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(" Select a Presentation ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46a28600!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Signage/Playlist.vue
// module id = 426
// module chunks = 1